/**
 * @generated SignedSource<<9bd48d535ebdcee2ec87bf58ec173b14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EventCreateZoomMeetingInput = {
  beginsAt?: any | null;
  endsAt?: any | null;
  practitionerUserID: string;
  practitionerAccountID: string;
  meetingTitle: string;
};
export type eventCreateZoomMeetingMutation$variables = {
  input: EventCreateZoomMeetingInput;
};
export type eventCreateZoomMeetingMutation$data = {
  readonly createZoomMeeting: {
    readonly meetingDetails: {
      readonly id: string;
      readonly hostId: string;
      readonly joinUrl: string;
      readonly password: string;
      readonly startUrl: string;
      readonly status: string;
      readonly timezone: string;
      readonly uuid: string;
    };
  };
};
export type eventCreateZoomMeetingMutation = {
  variables: eventCreateZoomMeetingMutation$variables;
  response: eventCreateZoomMeetingMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EventCreateZoomMeetingPayload",
    "kind": "LinkedField",
    "name": "createZoomMeeting",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZoomMeetingDetails",
        "kind": "LinkedField",
        "name": "meetingDetails",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hostId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "joinUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "password",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timezone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uuid",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "eventCreateZoomMeetingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "eventCreateZoomMeetingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f14d5166e5a504c0d51f2f1795ed349e",
    "id": null,
    "metadata": {},
    "name": "eventCreateZoomMeetingMutation",
    "operationKind": "mutation",
    "text": "mutation eventCreateZoomMeetingMutation(\n  $input: EventCreateZoomMeetingInput!\n) {\n  createZoomMeeting(input: $input) {\n    meetingDetails {\n      id\n      hostId\n      joinUrl\n      password\n      startUrl\n      status\n      timezone\n      uuid\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "39e5410dbadbcf4de927243aff484352";

export default node;
